<template>
  <div class="padded">
    <h2 class="text-warning" style="padding-top: 5vh;">Coming Soon</h2>
  </div>
</template>

<script>

export default {

}

</script>
